import React from 'react'
import '../Morepages/FreeShipping.css';

function FreeShipping() {
    return (
        <div className='free-shipping'>
            <img src="https://www.beyoung.in/api/catalog/homepage-3-10/desktop/number-1-strip-banner/1.jpg" alt="images-shipping" />
            <img src="https://www.beyoung.in/api/catalog/homepage-3-10/desktop/desktop-width/brand-icons-less-width.png" alt="images-shipping" />

        </div>
    )
}

export default FreeShipping